export default __webpack_public_path__ + "static/portrait-bg-192f0d0fbcbaa5e9a8de2efb842c01d8.png";